import React from "react";
export default class FormTerms extends React.Component {
  constructor(props){
    super(props)
    this.state = {
 
    }

  };

  render() {
    return (
      <div className="FieldGroupPresenter">
        <div className="modal-body" style={{ maxHeight: 'calc(100vh - 172px)', overflowY: 'auto' }}>
          <span
            onClick={this.props.onTogglePrivacy}
            dangerouslySetInnerHTML={{
              __html: this.props.helper_template.body,
            }}
          ></span>
        </div>
      </div>
    );
  };
};
